
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'

export default {
name: 'ApplyTryPage',
components: {
XInput,
XButton,
Group,
Cell,
Msg,
Selector,
Datetime
},
data () {
return {
detailInfo: {
complainant: '',
complainType: '',
projectName: '',
complainContent: '',
complainDate: '',
submitUser: '',
submitUserMobile: '',
remark: ''
},
code: this.$route.params.code,
submitSuccess: false,
editable: false,
buttons: [{
type: 'default',
text: '关闭',
onClick: this.closePage.bind(this)
}]
}
},
mounted: function () {
this.editable = !(this.code.indexOf('ndt') >= 0)
this.code = this.code.replace('ndt', '')
this.getComplainInfo()
},
methods: {
closePage: function () {


},
getComplainInfo: function () {
let that = this
let url = '/wxapi/user/getComplainInfo'
that.$axios.post(url, {}, {params: {code: this.code}}).then(function (res) {
if (res.meta.success) {
that.detailInfo = res.data
}
})
},
dealComplain: function () {
let that = this
let url = '/wxapi/user/dealCustomerComplain'
this.$axios.post(url, that.detailInfo).then(function (res) {
if (res.meta.success) {
that.submitSuccess = true
} else {
console.error(res.meta.message)
that.$Msgbox.alert(res.meta.message, '异常提示')
}
}).catch(function (error) {
console.info(error)
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/user/CustomerComplainDetail.vue